import React from 'react';
import { connect } from "react-redux";
import * as fileCrud from '../../../../crud/file.crud';
import Document from '../../_CustomComponents/DocumentV2';
import BiDynamicForm from '../../../../partials/layout/BiDynamicForm';
import BaseDocument from '../../_CustomComponents/BaseDocument';
import { Alert } from "react-bootstrap";
import { withSnackbar } from 'notistack';
import { GetCurrencyCodes } from "../../../../shared/lookup";
import moment from 'moment';
import DocumentDraftInfo from '../../_CustomComponents/DocumentDraftInfo';


export const calculateSubTotal = (obj) => {
    const prc1 = obj.othercumulativeprice ? obj.othercumulativeprice : 0;
    const prc2 = obj.otheramountpaid ? obj.otheramountpaid : 0;
    return prc1 + prc2;
}
export const calculateAmountDue = (obj) => {
    const prc1 = obj.subtotalpay ? obj.subtotalpay : 0;
    const prc2 = obj.subtotalretain ? obj.subtotalretain : 0;
    return prc1 - prc2;
}
// export const calculateSubTotalPreTax = (obj,totalcertified) => {
//     const prc1 = obj.otheramountretain ? obj.otheramountretain : 0;
//     const prc2 = props.contract.totalcertified;
//     return prc1 - prc2;
// }
export const calculateSubTotalPreTaxV2 = (obj) => {
    const prc1 = obj.otheramountretain ? obj.otheramountretain : 0;
    const prc2 = obj.lastpaymentcertificateamount ? obj.lastpaymentcertificateamount : 0;
    return prc1 - prc2;
}
export const calculateTotal = (obj) => {
    const prc1 = obj.othercertifiedpretax ? obj.othercertifiedpretax : 0;
    const prc2 = obj.othertaxamount ? obj.othertaxamount : 0;
    return prc1 + prc2;
}


class NotifyDocumentPage extends BaseDocument {
    constructor(props) {
        super(props);
        this.currencyCodes = GetCurrencyCodes(props.intl);
    }

    renderForm = () => {
        const { fields } = this.props.workflowItem;

        const bottomLabel = this.props.notificationType === 'Application' ? this.props.resources.PaymentAppliedPeriodLabel : this.props.resources.PaymentCertifiedPeriodLabel;

        const formatCurrency = (obj) => {
            const cur = this.currencyCodes.find(c => c.code === obj.currency)?.name || obj.currency;
            return cur;
        }

        const editorFormConfig = {
            currencyCode: this.props.contract.currency,
            fields: []
        };
        if (this.props.clauses) {
            editorFormConfig.fields.push(
                { label: fields.ApplicationType.label, dataField: 'paymenttype', required: fields.ApplicationType.required, editorType: 'dxSelectBox', editorOptions: { dataSource: this.props.clauses, valueExpr: 'field', displayExpr: 'display' } }
            );
        }
        if (this.props.notificationType === 'Application' && this.props.isCountOfUncompletedAssessmentDateActionsMoreThanZero()) {
            const payAssessActionsRaw = this.props.filteredManualActions.items
                .filter(a => a.type === 'PAY_ASSESS');

            const payAssessActions = payAssessActionsRaw
                .map(a => ({
                    value: a.duedate,
                    display: `Monthly Payment Assessment Due - ${moment(new Date(a.duedate)).format("DD/MM/YYYY")}`
                }));

            editorFormConfig.fields.push({
                label: this.props.globalResources.PAYMENT_ASSESSMENT_LABEL,
                dataField: 'assessmentdate',
                required: fields.AssessmentDate.required,
                editorType: 'dxSelectBox',
                editorOptions: {
                    dataSource: payAssessActions,
                    valueExpr: 'value',
                    displayExpr: 'display'
                }
            });

            const contractorActionsRaw = this.props.contractorPaymentApplicationActions();

            const contractorActions = contractorActionsRaw
                .map(a => ({
                    value: a.duedate,
                    display: `Payment Application Due - ${moment(a.duedate).format("DD/MM/YYYY")}`
                }));

            editorFormConfig.fields.push({
                label: (this.props.workflowsQA['21'] || {}).pageTitle + ' ' + this.props.intl.formatMessage({ id: "ACTIONS.FIELD.DUE_DATE" }),
                dataField: 'applicationdate',
                required: fields.AssessmentDate.required,
                dependOn: 'assessmentdate',
                dependOnValue: (item) => {
                    // if (item.applicationdate) {
                    //     return item.applicationdate;
                    // }

                    const selectedAssessmentDate = item.assessmentdate;

                    const closest = this.props.getClosestDate(
                        selectedAssessmentDate,
                        contractorActionsRaw,
                        'duedate'
                    );

                    const preSelectedValue = closest ? closest.duedate : null;

                    return preSelectedValue;
                },
                editorType: 'dxSelectBox',
                editorOptions: {
                    dataSource: contractorActions,
                    valueExpr: 'value',
                    displayExpr: 'display',
                    readOnly: true
                    //value: preSelectedValue//sets pre-selection
                }
            });
        } else {
            editorFormConfig.fields.push({
                label: fields.AssessmentDate.label,
                dataField: 'assessmentdate',
                required: fields.AssessmentDate.required,
                editorType: 'dxDateBox',
                validation: {
                    type: 'range',
                    min: new Date(1900, 0, 1),
                    max: new Date(2079, 5, 6),
                    warning: this.props.intl.formatMessage({ id: "GENERAL.FORMS.INVALID_DATE" })
                }
            });
        }
        editorFormConfig.fields.push(
            { label: fields.Summary.label, dataField: 'summary', required: fields.Summary.required, editorType: 'dxHtmlEditor' },
            { label: fields.Currency.label, value: formatCurrency },
            { label: fields.OtherCumulativePrice.label, dataField: 'othercumulativeprice', required: fields.OtherCumulativePrice.required, editorType: 'dxNumberBox' },
            { label: fields.OtherAmountPaid.label, dataField: 'otheramountpaid', required: fields.OtherAmountPaid.required, editorType: 'dxNumberBox' },
            { label: fields.SubTotalPay.label, dataField: 'subtotalpay', required: fields.SubTotalPay.required, editorType: 'dxNumberBox', value: calculateSubTotal },
            { label: fields.SubTotalRetain.label, dataField: 'subtotalretain', required: fields.SubTotalRetain.required, editorType: 'dxNumberBox', editorOptions: { min: 0 } },
            { label: fields.OtherAmountRetain.label, dataField: 'otheramountretain', required: fields.OtherAmountRetain.required, editorType: 'dxNumberBox', value: calculateAmountDue },
            { label: fields.LastPaymentCertificateAmount.label, dataField: 'lastpaymentcertificateamount', required: fields.LastPaymentCertificateAmount.required, editorType: 'dxNumberBox' },
        );
        if (this.props.contract.totalcertified != null) {
            const lastPaymentField = editorFormConfig.fields.find(itm => itm.dataField === 'lastpaymentcertificateamount');
            lastPaymentField.value = (obj) => obj.lastpaymentcertificateamount;
        }

        if (this.props.taxEnabled) {
            editorFormConfig.fields.push(
                { label: fields.SubTotalPay.label, dataField: 'othercertifiedpretax', required: fields.SubTotalPay.required, editorType: 'dxNumberBox', value: calculateSubTotalPreTaxV2 },
                { label: this.props.resources.TaxSupplierLabel, dataField: 'othertaxamount', required: fields.OtherTaxAmount.required, editorType: 'dxNumberBox', },
                { label: bottomLabel, dataField: 'othercertfiedamount', required: true, editorType: 'dxNumberBox', value: calculateTotal }
            )
        }
        else {
            editorFormConfig.fields.push(
                { label: bottomLabel, dataField: 'othercertfiedamount', required: true, editorType: 'dxNumberBox', value: calculateSubTotalPreTaxV2 }
            )
        }

        if (this.props.poNumberEnabled) {
            editorFormConfig.fields.push(
                { label: fields.PurchaseOrderNumber.label, dataField: 'purchaseordernumber', required: fields.PurchaseOrderNumber.required }
            );
        }

        const notificationItem = { ...this.props.notification };

        if (this.props.notificationType === 'Application' &&
            notificationItem.assessmentdate &&
            !notificationItem.applicationdate
        ) {
            const contractorActionsRaw = this.props.contractorPaymentApplicationActions();

            const closest = this.props.getClosestDate(
                notificationItem.assessmentdate,
                contractorActionsRaw,
                'duedate'
            );

            notificationItem.applicationdate = closest ? closest.duedate : null;
        }

        return (
            <>
                {this.props.resources.WarningBanner && (
                    <Alert variant="warning" >
                        <p>
                            {this.props.resources.WarningBanner}
                        </p>
                    </Alert>
                )}
                <BiDynamicForm
                    item={notificationItem}
                    valueChangeHandler={this.props.fieldChanged}
                    config={editorFormConfig}
                    customFields={(this.props.customFields || {}).COMMUNICATION}
                    assetFieldsEnabled={this.props.workflowItem.assetFieldsEnabled}
                />
            </>
        );
    }

    uploadFile = (data, config) => {
        const { companyid, projectid, contractid } = this.props.contract;
        return fileCrud.uploadContractNotificationFiles(companyid, projectid, contractid, this.props.documentType, this.props.notification.paymentcertificateid, this.props.workflowItem.id, this.props.workflowItem.config.quotationWorkflowID, data, config)
    }

    render() {
        const documentIsFinal = this.props.notification.showtasknotification === 1;
        const { createby, createdate, lastdraftedbyname, lastdrafteddate, lastdraftednotifiedtoname } = this.props.notification;

        return (
            <>
                <DocumentDraftInfo
                    documentIsFinal={documentIsFinal}
                    createbyname={createby}
                    createdate={createdate}
                    lastdraftedbyname={lastdraftedbyname}
                    lastdrafteddate={lastdrafteddate}
                    lastdraftednotifiedtoname={lastdraftednotifiedtoname}
                />
                <Document
                    key={documentIsFinal}
                    docConfig={this.props.notification.pdfjsoncontent}
                    isFinal={documentIsFinal}
                    printDivRef={this.props.printDivRef}
                    workflowItem={this.props.workflowItem}
                    contract={this.props.contract}
                    reference={this.props.notification.referenceid}
                    form={documentIsFinal ? null : this.renderForm()}
                    uploadMethod={documentIsFinal ? null : this.uploadFile}
                    onFilesCountChanged={this.props.onFilesCountChanged}
                    files={this.props.files}
                    notificationid={this.props.notificationid}
                    documentType={this.props.documentType}
                    customFields={(this.props.customFields || {}).COMMUNICATION}
                    customFieldValues={this.props.notification.customfieldvalues}
                    assetid={this.props.notification.assetid}
                    saving={this.props.saving}
                    onFileUploadFinish={this.props.onFileUploadFinish}
                    onFileUploadStart={this.props.onFileUploadStart}
                />
            </>

        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
    filteredManualActions: store.contract.filteredManualActions,
    UI_VERSION: store.application.UI_VERSION,
});

export default withSnackbar(connect(mapStateToProps)(NotifyDocumentPage));
